var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFavorite = function SvgFavorite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8136 0C13.0451 0.000893692 12.285 0.159213 11.5801 0.465192C10.8752 0.771172 10.2405 1.21832 9.71504 1.77907C8.94504 0.957268 7.94577 0.385923 6.84696 0.139205C5.74815 -0.107514 4.60054 -0.0182115 3.55313 0.395519C2.50571 0.809249 1.60685 1.5283 0.973248 2.45932C0.339644 3.39034 0.000554456 4.49034 0 5.61651C0 11.2087 9.01981 16.6977 9.41145 16.9133C9.50589 16.97 9.61398 17 9.72415 17C9.83432 17 9.94242 16.97 10.0369 16.9133C10.4103 16.6977 19.4301 11.2087 19.4301 5.61651C19.4285 4.12741 18.8362 2.69976 17.7833 1.64681C16.7303 0.593861 15.3027 0.00160723 13.8136 0Z",
    fill: "#FB4E4E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFavorite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/favorite.abcacca9.svg";
export { ForwardRef as ReactComponent };